import { useQuery } from '@tanstack/react-query'

import { useDebounce } from '@hooks/useDebounce'
import type { Entity } from '@models/Entity'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import {
  MIN_QUERY_SIZE,
  fetchContactpersoonAccounts,
  initialState,
} from '../services/fetchContactpersoonAccounts'

export { useContactpersoonAccounts, queryKey }

const queryKey = 'contactpersoon-accounts'

const useContactpersoonAccounts = ({
  entity,
  text,
}: {
  entity: Entity
  text: string
}) => {
  const { hasPermissions } = useAuthenticatedUser()
  const debouncedText = useDebounce(text.trim())

  const { data, isFetching } = useQuery({
    queryFn: () => fetchContactpersoonAccounts({ entity, text: debouncedText }),
    queryKey: [queryKey, entity, debouncedText],
    enabled: hasPermissions,
  })

  // De debounce vertraagt alleen het zoeken; te korte tekst wist direct
  // de resultaten.
  const searchable = text.trim().length >= MIN_QUERY_SIZE

  return {
    data: searchable ? data || initialState.data : initialState.data,
    isLoading: searchable && (isFetching || debouncedText !== text.trim()),
  }
}
